import React from 'react';
import { Star, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { API_URL } from './potwApi';

const statLine = (c) => {
  const src = c.gp > 1 ? c.per_game : c;
  const parts = [`${src.pts} PTS`, `${src.reb} REB`, `${src.ast} AST`];
  return c.gp > 1 ? `${c.gp} games · ${parts.join(' · ')} per game` : parts.join(' · ');
};

const Avatar = ({ c }) => (c.headshot_path
  ? <img src={`${API_URL}/api/files/${c.headshot_path}`} alt="" className="w-11 h-11 rounded-full object-cover shrink-0" />
  : <div className="w-11 h-11 rounded-full bg-[#00247D]/10 text-[#00247D] font-bold flex items-center justify-center shrink-0">{(c.name || '?')[0]}</div>);

const CandidateRow = ({ c, i, picked, suggested, onPick, busy }) => (
  <div data-testid={`potw-candidate-${i}`}
    className={`flex items-center gap-3 p-3 rounded-xl border transition-colors ${picked ? 'border-amber-400 bg-amber-50' : 'border-slate-200 bg-white hover:border-slate-300'}`}>
    <span className="w-5 text-xs font-bold text-slate-400 text-center">{i + 1}</span>
    <Avatar c={c} />
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-1.5 min-w-0">
        <span className="font-semibold text-slate-800 truncate" data-testid={`potw-candidate-name-${i}`}>{c.name}</span>
        {suggested && <span className="text-[10px] font-bold uppercase text-[#00247D] bg-blue-50 px-1.5 py-0.5 rounded shrink-0" data-testid={`potw-suggested-badge-${i}`}>Suggested</span>}
      </div>
      <div className="text-xs text-slate-500 truncate">{c.team_name}</div>
      <div className="text-xs text-slate-600 truncate">{statLine(c)}</div>
    </div>
    <div className="text-right shrink-0">
      <div className="text-lg font-black text-[#00247D] leading-none" data-testid={`potw-candidate-per-${i}`}>{c.per}</div>
      <div className="text-[10px] text-slate-400 uppercase">Eff.</div>
    </div>
    {picked ? (
      <span className="inline-flex items-center gap-1 text-[11px] font-bold text-amber-700 shrink-0 w-[68px] justify-center" data-testid="potw-picked-badge">
        <Star className="w-3.5 h-3.5 fill-amber-500 text-amber-500" />Picked
      </span>
    ) : (
      <Button variant="outline" size="sm" onClick={() => onPick(c)} disabled={busy} className="w-[68px] shrink-0" data-testid={`potw-pick-btn-${i}`}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Pick'}
      </Button>
    )}
  </div>
);

export const CandidateList = ({ candidates, pickedKey, suggestedKey, onPick, busyKey }) => (
  <div className="space-y-2" data-testid="potw-candidates">
    {candidates.map((c, i) => (
      <CandidateRow key={c.key} c={c} i={i} picked={c.key === pickedKey} suggested={c.key === suggestedKey}
        onPick={onPick} busy={!!busyKey} />
    ))}
  </div>
);
